module.exports = __webpack_public_path__ + "img/facebook-partner.5ca2848d.png";